import { createFileRoute } from "@tanstack/react-router";

import { ProfilePage } from "@/components/Pages/Profile";

export const Route = createFileRoute("/_guard/profile/")({
  component: ProfilePage,
});
